import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

//
import { Card, Row, Col, Badge, Button } from "react-bootstrap";
import Moment from "react-moment";

//
import Ribbon from "../general/Ribbon";
import ImageBox from "../general/ImageBox";

//
import { iconImage } from "../../redux/features/coins/actions";

//
import SwiperCore, { Navigation, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";

SwiperCore.use([Navigation, Scrollbar, A11y]);

function DesktopAlertItem({ data, ribbon = false }) {
  const convertStatus = (value) => {
    if (value === "won") return "Won";
    if (value === "stopLoss") return "Stoploss";
    if (value === "trendChanged") return "Trend Changed";
    return "Pending";
  };

  const statusColor = (value) => {
    if (value === "won") return "success";
    if (value === "stopLoss") return "danger";
    if (value === "trendChanged") return "muted";
    return "warning";
  };

  const convertProfit = (value) => {
    if (value > 0) return "success";
    if (value < 0) return "danger";
    return "muted";
  };

  return (
    <Col xs={12} className="overflow-hidden gutter-b">
      <Card>
        {ribbon && (
          <Ribbon content="Hot Coins 🔥 . Hot Coins 🔥 . Hot Coins 🔥" />
        )}
        <Card.Body>
          <Row>
            <Col md={4} xl={3} xxl={2}>
              <div className={`coin-info ${ribbon ? "ribbon" : ""}`}>
                <div>
                  <ImageBox src={iconImage(data.pair)} />

                  <div>
                    <div className="d-flex align-items-baseline">
                      <h5>{data.name}</h5>
                      <p className="fw-bolder">({data.pair})</p>
                    </div>

                    <small className="last-update">
                      Last Update{" "}
                      <Moment fromNow>{data.signals[0].created_at}</Moment>
                    </small>
                  </div>
                </div>

                <Link to={`/app/coin-detail/${data.pair.split("/")[0]}`}>
                  <Button variant="info" className="radius">
                    See All
                  </Button>
                </Link>
              </div>
            </Col>
            <Col md={8} xl={9} xxl={10}>
              <Swiper
                dir="rtl"
                slidesPerView={1.2}
                spaceBetween={10}
                modules={[Navigation, Scrollbar, A11y]}
                navigation
                breakpoints={{
                  576: {
                    slidesPerView: 2.2,
                  },

                  992: {
                    slidesPerView: 2.2,
                  },

                  1200: {
                    slidesPerView: 3.2,
                  },

                  1400: {
                    slidesPerView: 4.2,
                  },
                }}
              >
                {data.signals.map((item) => (
                  <SwiperSlide key={item.id}>
                    <Card className="item">
                      <Card.Header>
                        <small className="fw-bold" dir="ltr">
                          <Moment utc format="h:mm A">
                            {item.created_at}
                          </Moment>{" "}
                          (UTC)
                        </small>
                      </Card.Header>
                      <Card.Body>
                        <div className="status-rate">
                          <div>
                            <small className="fw-bold text-muted">
                              PROFIT/LOSS
                            </small>
                            <h4
                              dir="ltr"
                              className={`text-${convertProfit(+item.profit)}`}
                            >
                              {item.profit}%
                            </h4>
                          </div>

                          <Badge
                            bg={item.status === "closed" ? "dark" : "secondary"}
                          >
                            {item.status === "closed" ? "Closed" : "Pending"}
                          </Badge>
                        </div>

                        <p className="type">
                          <small
                            className="d-flex flex-column align-items-center"
                            style={{ minWidth: "max-content" }}
                          >
                            <span
                              className={
                                item.side === "BUY"
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {item.side}
                            </span>
                            <span
                              className={`text-${statusColor(item.winStatus)}`}
                            >
                              {convertStatus(item.winStatus)}
                            </span>
                          </small>
                        </p>

                        <div className="target-action">
                          <div>
                            <small className="smaller text-muted fw-bold">
                              Target
                            </small>
                            <small className="text-dark fw-bold">
                              {Number(item.target)
                                .toFixed(data.pair === "BTC" ? 2 : 8)
                                .replace(/\.?0+$/, "")}
                            </small>
                          </div>
                          <div className="text-start">
                            <small className="smaller text-muted fw-bold">
                              Enter price
                            </small>
                            <small className="text-dark fw-bold">
                              {Number(item.entryPrice)
                                .toFixed(data.pair === "BTC" ? 2 : 8)
                                .replace(/\.?0+$/, "")}
                            </small>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
}

DesktopAlertItem.propTypes = {
  data: PropTypes.object.isRequired,
  ribbon: PropTypes.bool,
};

export default DesktopAlertItem;
